import {
  SET_PAGE,
  SET_PAGE_SIZE,
  SET_TOTAL_PAGES,
  REQUEST_DATA_SUCCESS
} from './mutation-types'

export default {
  [SET_PAGE](state, payload) {
    state.currentPage = payload
  },

  [SET_TOTAL_PAGES](state, payload) {
    state.totalPages = payload
  },

  [SET_PAGE_SIZE](state, payload) {
    state.pageSize = payload
  },

  [REQUEST_DATA_SUCCESS](state, payload) {
    state.items = payload
  }
}
